import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
@Injectable({
    providedIn: "root",
})
export class QuestionTranformationService {

    private textReplacements : DynamicTextModel[] = [
        {textKey:"<PreScreenMaintainExemptStatus_date>", value:"2021-08-29"},
        {textKey:"<PreScreenLastCovidTest_date>", value:"2021-08-20"}
    ];
    constructor(
        private http: HttpClient,
        @Inject("BASE_URL") private baseUrl: string
    ) { }

    replaceQuestionText(questionText: string, questionFieldName: string): string {
        let replacedText = questionText;
        let keyPattern = "<" + questionFieldName + "_"; //ex. <PreScreenLastCovidTest_

        if (questionText.indexOf(keyPattern) >= 0) {
            let selectedKeyValuePairs = this.textReplacements.filter(r => r.textKey.indexOf(keyPattern) >= 0);
            selectedKeyValuePairs.forEach(kvPair => {
                replacedText = replacedText.replace(kvPair.textKey, kvPair.value);
            });
            console.log(replacedText);
        }

        return replacedText;
    }

    async loadDynamicQuestionTexts(corpId: string) {
        if (this.textReplacements.filter(r => r.textKey == '<PreScreen-MaskReminder_MaskUpdateMessage>').length > 0)
            return;
            
        this.textReplacements = await this.http.get<DynamicTextModel[]>(this.baseUrl + "api/survey/dynamic-texts/"+corpId).toPromise();
    }

    replaceMaskMessage(resultText: string){
        let replacedText = resultText;
        let foundKey = this.textReplacements.find(r=>r.textKey == '<PreScreen-MaskReminder_MaskUpdateMessage>');
        if(foundKey){
            replacedText = resultText.replace(foundKey.textKey, foundKey.value);
        }
        else{
            replacedText = resultText.replace('<PreScreen-MaskReminder_MaskUpdateMessage>', 'a mask'); //default just in case
        }

        return replacedText;
    }

    // replaceIntTravelCovidTestingDate(resultText: string) {
    //     let replacedText = resultText;
    //     let foundKey = this.textReplacements.find(r => r.textKey == '<CovidExposure_IntTravelCovidTestingDate>');
    //     if (foundKey) {
    //       replacedText = resultText.replace(foundKey.textKey, foundKey.value);
    //     }
    //     //else {
    //     //  replacedText = resultText.replace('<PreScreen-MaskReminder_MaskUpdateMessage>', 'a mask'); //default just in case
    //     //}

    //     return replacedText;
    // }
}

export interface DynamicTextModel{
    textKey: string;
    value: string;
}
